export default __webpack_public_path__ + "img/allergy-vegetarian.3385061f62982640964851c81657f6a3.svg";